<template>
<!-- 新增版本 -->
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="650px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="from-body">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="auto"
        class="demo-ruleForm"
        :rules="rules"
      >
        <el-form-item :label="$t('pages.system.text14')" prop="version">
          <el-input v-model="ruleForm.version"></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.system.text15')" prop="intro">
          <el-input
            v-model="ruleForm.intro"
            type="textarea"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.system.text16')" prop="filePath">
          <DiliUploadFile
            :limit="1"
            accept=".apk"
            :fileList="fileList"
            @remove="remove"
            @success="success"
            :uploaDisabled="false"
          />
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{$t('button.cancel')}}</el-button>
      <el-button type="primary" @click="submit">{{$t('button.determine')}}</el-button>
    </span>
  </el-dialog>
</template>


<script>
import DiliUploadFile from "../../../../components/pubilc/dili-uploadfile.vue";
import { validatEdition, validatDescribe } from "../../../../utils/util/test";
import { mapState } from "vuex";
export default {
  data() {
    return {
      title: this.$t('pages.system.text17'),
      fileList: [],
      ruleForm: {
        belongCustomerId: "", //归属客户id
        fileHash: "", //文件hash
        fileName: "", //文件名称
        filePath: "", //文件路径
        fileSize: "", //文件大小
        intro: "", //版本说明
        version: "", //版本号
        appCode:''
      },
      rules: {
        version: [{ validator: validatEdition, trigger: "blur" }],
        intro: [
          { validator: validatDescribe, trigger: "blur" },
          {
            required: true,
            message: this.$t('pages.system.text20'),
            trigger: "blur",
          },
        ],
        filePath: [
          {
            required: true,
            message: this.$t('pages.system.text19'),
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    DiliUploadFile,
  },
  computed: {
    ...mapState(["platformData"]),
  },
  watch: {
    dialogVisible(newValue) {
      if (newValue) {
        if (this.dialogStatus == 0) {
          this.title = this.$t('pages.system.text17');
        } else {
          this.title = this.$t('pages.system.text18');
          this.ruleForm = {
            belongCustomerId: "", //归属客户id
            fileHash: this.currentVersionManage.fileHash, //文件hash
            fileName: this.currentVersionManage.fileName, //文件名称
            filePath: this.currentVersionManage.filePath, //文件路径
            fileSize: this.currentVersionManage.fileSize, //文件大小
            intro: this.currentVersionManage.intro, //版本说明
            version: this.currentVersionManage.version, //版本号
            id: this.currentVersionManage.id,
          };
          let arr = [];
          arr.push({
            url: this.currentVersionManage.filePath,
            name: this.currentVersionManage.fileName,
          });
          this.fileList = arr;
        }
      }
    },
  },
  props: ["dialogVisible", "dialogStatus", "currentVersionManage"],
  methods: {
    //取消
    handleClose() {
      this.ruleForm = {
        belongCustomerId: "", //归属客户id
        fileHash: "", //文件hash
        fileName: "", //文件名称
        filePath: "", //文件路径
        fileSize: "", //文件大小
        intro: "", //版本说明
        version: "", //版本号
        id: null,
      };
      this.fileList = [];
      this.$refs['ruleForm'].resetFields();
      this.$emit("dialogClose");
    },
    //删除
    remove(e) {
      const i = this.fileList.findIndex((x) => x.name == e);
      this.fileList.splice(i, 1);
      this.ruleForm.fileHash = ""; //文件hash
      this.ruleForm.fileName = ""; //文件名称
      this.ruleForm.filePath = ""; //文件路径
      this.ruleForm.fileSize = ""; //文件大小
    },
    //上传成功
    success(e) {
      this.fileList = e.fileList;
      this.ruleForm.fileHash = e.hash; //文件hash
      this.ruleForm.fileName = e.name; //文件名称
      this.ruleForm.filePath = e.url; //文件路径
      this.ruleForm.fileSize = e.size; //文件大小
    },
    //确定
    submit() {
      this.ruleForm.belongCustomerId = this.platformData.id;
      this.ruleForm.appCode = this.platformData.appCode;
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.dialogStatus == 0) {
            this.request.versionManagementSave(this.ruleForm).then(() => {
              this.$message.success(this.$t('pages.system.text21'));
              this.$emit("versionManagementList");
              this.handleClose();
            });
          } else {
            this.request.versionManagementUpdate(this.ruleForm).then(() => {
              this.$message.success(this.$t('pages.system.text22'));
              this.$emit("versionManagementList");
              this.handleClose();
            });
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.from-body {
  padding: 0 40px;
  box-sizing: border-box;
}
</style>